<!-- BEGIN: Subheader -->
<div class="m-subheader ">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">Nuevo Cupón</h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a [routerLink]="''" class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a [routerLink]="'/coupons'" class="m-nav__link">
                        <span class="m-nav__link-text">Cupones</span>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a *ngIf="coupon.id == null" [routerLink]="'/coupons/create'" class="m-nav__link">
                        <span class="m-nav__link-text">Crear Cupón</span>
                    </a>
                    <a *ngIf="coupon.id != null" [routerLink]="['/coupons/edit', coupon.id]" class="m-nav__link">
                        <span class="m-nav__link-text">Editar Cupón</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content">
    <div class="row">
        <div class="col-md-12">
            <!--begin::Portlet-->
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 *ngIf="coupon.id == null" class="m-portlet__head-text">
                                Crear Cupón
                            </h3>
                            <h3 *ngIf="coupon.id != null" class="m-portlet__head-text">
                                Editar Cupón - {{coupon.code}}
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                        <ul class="m-portlet__nav">
                            <li class="m-portlet__nav-item">
                                <a [routerLink]="'/coupons'"
                                   class="m-portlet__nav-link btn btn-lg btn-secondary m-btn m-btn--outline-2x m-btn--air m-btn--icon m-btn--icon-only m-btn--pill  m-dropdown__toggle">
                                    <i class="flaticon-reply"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <form [formGroup]="form" (ngSubmit)="sendForm()" class="m-form m-form--label-align-right">
                    <div class="m-portlet__body">
                        <div class="m-form__section m-form__section--first">
                            <div class="form-group m-form__group row">
                                <div class="col-10 ml-auto">
                                    <h3 class="m-form__section">Información del Cupón</h3>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Código:</label>
                                <div class="col-lg-6">
                                    <input formControlName="code" class="form-control m-input" placeholder="Código"
                                           [ngClass]="{ 'is-invalid': submitted && f.code.errors }">
                                    <div *ngIf="submitted && f.code.errors" class="invalid-feedback">
                                        <div *ngIf="f.code.errors.required">Código obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Descripción:</label>
                                <div class="col-lg-6">
                                    <textarea formControlName="description" class="form-control m-input" rows="3"
                                              placeholder="Descripción"
                                              [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
                                    <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                        <div *ngIf="f.description.errors.required">Descripción obligatoria</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Descuento:</label>
                                <div class="col-lg-6">
                                    <input formControlName="discount" class="form-control m-input" placeholder="Descuento"
                                           [ngClass]="{ 'is-invalid': submitted && f.discount.errors }">
                                    <div *ngIf="submitted && f.discount.errors" class="invalid-feedback">
                                        <div *ngIf="f.discount.errors.required">Descuento obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Fecha de Inicio:</label>
                                <div class="col-lg-6">
                                    <input formControlName="start" type="date" class="form-control m-input"
                                           [ngClass]="{ 'is-invalid': submitted && f.start.errors }">
                                    <div *ngIf="submitted && f.start.errors" class="invalid-feedback">
                                        <div *ngIf="f.start.errors.required">Fecha de inicio obligatoria</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Fecha de Fin:</label>
                                <div class="col-lg-6">
                                    <input formControlName="end" type="date" class="form-control m-input"
                                           [ngClass]="{ 'is-invalid': submitted && f.end.errors }">
                                    <div *ngIf="submitted && f.end.errors" class="invalid-feedback">
                                        <div *ngIf="f.end.errors.required">Fecha de fin obligatoria</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Estado:</label>
                                <div class="col-lg-6">
                                    <select formControlName="status" class="form-control m-input"
                                            [ngClass]="{ 'is-invalid': submitted && f.status.errors }">
                                        <option value="1">Activo</option>
                                        <option value="0">Inactivo</option>
                                    </select>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Estado obligatorio</div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group m-form__group row">
                                <label class="col-lg-2 col-form-label">Límite:</label>
                                <div class="col-lg-6">
                                    <input formControlName="limit" class="form-control m-input" placeholder="Límite"
                                           [ngClass]="{ 'is-invalid': submitted && f.limit.errors }">
                                    <div *ngIf="submitted && f.limit.errors" class="invalid-feedback">
                                        <div *ngIf="f.limit.errors.required">Límite obligatorio</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-portlet__foot m-portlet__foot--fit">
                        <div class="m-form__actions">
                            <div class="row">
                                <div class="col-2">
                                </div>
                                <div class="col-7">
                                    <button type="submit" [disabled]="loading"
                                            class="btn btn-accent m-btn m-btn--air m-btn--custom"
                                            [ngClass]="{'m-loader m-loader--light m-loader--right': loading}">
                                        Guardar Cambios
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>